import { render, staticRenderFns } from "./HomeLayout.vue?vue&type=template&id=a2649530&scoped=true"
import script from "./HomeLayout.vue?vue&type=script&lang=js"
export * from "./HomeLayout.vue?vue&type=script&lang=js"
import style0 from "./HomeLayout.vue?vue&type=style&index=0&id=a2649530&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2649530",
  null
  
)

export default component.exports